export default "__VITE_ASSET__ee172a2b__"